import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import TechnicalView from "./TechnicalView";
import TechnicalViewResponsive from "./TechnicalViewResponsive";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import userActions from "./actions";
import { useSelector } from "react-redux";
import { getItem } from '../../local-store'

const TechnicalViewContainer = () => {
  const { isMobile } = useGetViewPortDimensions();
  const {
    loadIrrigationDistricts,
    loadAgricultureDistrictWater,
    loadWaterDeliveries,
    loadCityMetrics,
    loadCities,
    loadCityWaterSources,
    loadEntityEntitlements,
    loadTribes,
    // loadTribeMetrics,
    // setIsTribe,
    // setEntitlementYear,
    loadEntitlementsByYear,
    loadAccessDifferenceRange,
    loadCitiesWaterUse,
    setChart,
    // resetSelectedCity,
    toggleAboutDrawer,
    loadCityMetricsGauge,
    loadIndustryMetrics,
    loadWesternArizonaEntitlements,
    loadWesternArizonaEntities,
    loadWesternArizonaPriorityEntitlements,
    loadWesternArizonaEntityEntitlements,
    loadCitiesPopulation,
    setScenarioSelected,
    loadScenarios,
  } = userActions();
  const { chart,city_selected,scenario_selected, is_tribe, tribe_selected, is_western } = useSelector((state) => state.technical_view);

  const componentMount = () => {
    loadScenarios();
    loadIrrigationDistricts();
    loadAgricultureDistrictWater();
    loadWaterDeliveries();
    loadCityMetrics(44); //as default, we will show the information for the first item in the dropdown menu
    loadCityWaterSources(44);
    loadEntityEntitlements(44, scenario_selected.value);
    loadCities();
    loadCitiesPopulation();
    loadTribes();
    loadWesternArizonaEntities();
    // loadTribeMetrics(52);
    loadEntitlementsByYear(2024,scenario_selected.value);
    loadWesternArizonaEntitlements(scenario_selected.value);
    loadWesternArizonaPriorityEntitlements(scenario_selected.value);
    loadWesternArizonaEntityEntitlements(116, scenario_selected.value);
    loadAccessDifferenceRange(scenario_selected.value);
    loadCitiesWaterUse();
    loadCityMetricsGauge(44);
    loadIndustryMetrics();

    let item = getItem('dropdownData')
    if(item) {
      setScenarioSelected(item)
    }

    return () => {
      setChart("colorado_river_access");
    };
  }
  useEffect(componentMount, []);

  // set location filter value to saved value for each chart
  const setChartFunction = () => {
    if (chart==="colorado_river_access"){
      if (is_tribe){
        loadEntityEntitlements(tribe_selected.tribe_id, scenario_selected.value);
      }
    }
    else if(chart==="access_per_capita"){
      loadCityMetrics(city_selected.city_id);
      loadEntityEntitlements(city_selected.city_id, scenario_selected.value);
      loadCityWaterSources(city_selected.city_id);
    }
    else if (chart==="central_az_water_use"){
      loadCityMetrics(city_selected.city_id);
    }
    else if ("colorado_river_water_access"){
      loadCityMetrics(city_selected.city_id);
      loadEntityEntitlements(city_selected.city_id, scenario_selected.value);
    }
    else if ("water_use_versus_access"){
      if (!is_western)
        loadCityMetrics(city_selected.city_id);
    }
  }
  useEffect(setChartFunction, [chart]);

  // Removed to fix bug where city_selected is not updated when changing charts
  // useEffect(() => {
  //   if (isMobile) {
      // resetSelectedCity();
      // loadCityMetrics(1);
      // loadCityWaterSources(1);
  //   }
  // }, [chart]);

  // Needed to hide About Drawer by default on mobile devices.
  const mobileDisplay = () => {
    if (isMobile) {
      toggleAboutDrawer({ isMobile: true });
    }
  }
  useEffect(mobileDisplay, [isMobile]);
  return (
    <Grid container>
      {/* <FilterTogglebar /> */}
      {!isMobile ? <TechnicalView /> : <TechnicalViewResponsive />}
    </Grid>
  );
};

export default TechnicalViewContainer;